/* ═══════════════════════════════════════════════════════════════════
   B1 — Calibration profiles (2026-06)

   Single env-keyed defaults profile. Switch with:
       REACT_APP_CALIBRATION_PROFILE=phase0
   Default is "enterprise" — the values the product shipped with.

   ✅ PHASE-0 VALUES RATIFIED BY FOUNDER (R3, 2026-06) and merged as the
      ACTIVE profile (REACT_APP_CALIBRATION_PROFILE=phase0 in .env).
      Backend twin: routes/kpi_recommendations.py (CALIBRATION_PROFILE)
      — keep the two in lockstep.
   ═══════════════════════════════════════════════════════════════════ */

export const ACTIVE_PROFILE =
  process.env.REACT_APP_CALIBRATION_PROFILE === 'phase0' ? 'phase0' : 'enterprise';

// ── Suggested budget bands (Step 1 hint under the budget field) ──────
const BUDGET_HINTS = {
  enterprise: { Performance: '$150K–$500K', Branding: '$100K–$350K' },
  // phase0 (1 brand · ~5 creators · measure-only): RATIFIED R3 2026-06
  phase0:     { Performance: '$2K–$10K',    Branding: '$1K–$5K' },
};

export function budgetHint(waveType) {
  const bands = BUDGET_HINTS[ACTIVE_PROFILE];
  return `Suggested: ${waveType === 'Performance' ? bands.Performance : bands.Branding}`;
}

// ── Estimated-creators floor (Step 1 "minimum creators needed") ──────
const EST_CREATOR_FLOORS = { enterprise: 50, phase0: 3 };
export const EST_CREATOR_FLOOR = EST_CREATOR_FLOORS[ACTIVE_PROFILE];

// ── Native performance-KPI benchmark strings ─────────────────────────
// phase0 overrides RATIFIED (R3, 2026-06). Keys must exactly match the
// KPI `name` fields in BASE_PERF_KPIS (constants.js). Unlisted KPIs keep
// their enterprise benchmark string.
const PHASE0_KPI_BENCHMARKS = {
  TikTok: {
    'GMV Target': '$500–$5K',
    'Orders': '10–100',
    'ROAS': '2x–4x',
  },
  Instagram: {
    'Link Clicks': '200–2K',
    'Add-to-Cart': '10–100',
    'ShopMy Revenue': '$250–$2.5K',
    'Saves': '50–500',
    'Profile Visits': '250–2.5K',
  },
  YouTube: {
    'Watch Time (hrs)': '20–200 hrs',
  },
};

export function applyKpiBenchmarkProfile(baseKpis) {
  if (ACTIVE_PROFILE !== 'phase0') return baseKpis;
  const out = {};
  Object.entries(baseKpis).forEach(([platform, kpis]) => {
    const overrides = PHASE0_KPI_BENCHMARKS[platform] || {};
    out[platform] = kpis.map((k) =>
      overrides[k.name] ? { ...k, benchmark: overrides[k.name] } : k,
    );
  });
  return out;
}
